import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Provider } from 'src/app/models/administration/provider';
import { HistoryInventory } from 'src/app/models/inventory/history-inventory';
import { InputOrOutputInventory } from 'src/app/models/inventory/input-or-output-inventory';
import { Item } from 'src/app/models/inventory/item';
import { PurchaseOrder } from 'src/app/models/inventory/purchase-order';
import { Warehouse } from 'src/app/models/inventory/warehouse';
import { Notification } from 'src/app/models/notification/notification';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { GeneratePdfFosilService } from 'src/app/services/generate-pdf-fosil.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UtilsServiceService } from 'src/app/services/utils-service.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  ExportDataService,
  FunctionsService,
  HeaderFilters,
  HttpService,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  SessionService,
  TableColumns,
  TableConfiguration,
  params,
} from 'brainloper-ui';

@Component({
    selector: 'app-purchase-order',
    templateUrl: './purchase-order.component.html',
    styleUrls: ['./purchase-order.component.scss'],
    standalone: false
})
export class PurchaseOrderComponent implements OnInit {
  public urlTablePO: string = `${EndpointDictionary.PurchaseOrder.PURCHASE_ORDER_TABLE}`;
  private urlCrudPO: string = `${EndpointDictionary.PurchaseOrder.CRUD_PURCHASE_ORDER}`;
  private urlItems: string = `${EndpointDictionary.Item.ITEM_COMBO}`;
  private urlUser: string = `${EndpointDictionary.User.USER_COMBO}`;
  private urlProvider: string = `${EndpointDictionary.Provider.PROVIDER_COMBO}`;
  private urlOrdersStatuses: string = `${EndpointDictionary.PurchaseOrder.PURCHASE_ORDERs_STATUSES_COMBO}`;
  private urlWarehouses: string = `${EndpointDictionary.Warehouse.WAREHOUSE_COMBO}`;

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Orden de Compra',
      current: true,
    },
  ];

  public labels = [];
  public selected = new UntypedFormControl(0);
  public warehouses: Warehouse[];

  // tabla orden compra
  public reloadTablaPO = new EventEmitter<any>();
  public configurationPO: TableConfiguration = {
    add: true,
    edit: true,
    selectable: true,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    hideTitle: true,
    exportXslx: true,
    delete: true,
    exportXslxByRow: true,
    view: true,
    sendEmail: true,
    print: true,
  };
  public columnsPO: TableColumns<PurchaseOrder>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'number',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'warehouse',
      label: 'Bodega',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'created',
      label: 'Fecha Creación',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'receptionDate',
      label: 'Fecha Recepción',
      type: 'date',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'requestsName',
      label: 'Solicita',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'authorizeName',
      label: 'Autoriza',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'providerName',
      label: 'Proveedor',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'itemsCount',
      label: 'Número de Items',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCost',
      label: 'Costo Total',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'stateName',
      label: 'Estado de Orden',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  headerFileXlsm: Array<params> = [
    { id: 'consecutive', value: 'Consecutivo' },
    { id: 'warehouse', value: 'Bodega' },
    { id: 'created', value: 'Fecha de Creación' },
    { id: 'receptionDate', value: 'Fecha de Recepción' },
    { id: 'requestsName', value: 'Solicita' },
    { id: 'authorizeName', value: 'Autoriza' },
    { id: 'providerName', value: 'Proveedor' },
    { id: 'itemsCount', value: 'Número de Items' },
    { id: 'totalCost', value: 'Costo Total' },
    { id: 'stateName', value: 'Estado de Orden' },
  ];

  //tabla detalle
  public reloadTablaDetails = new EventEmitter<any>();
  public dataDetails: Array<InputOrOutputInventory> = [];
  public configurationDetails: TableConfiguration = {
    exportXslx: true,
    hideTitle: true,
    primaryKey: 'id',
  };
  public columnsDetails: TableColumns<Item>[] = [
    {
      ID: 'code',
      label: 'Código Item',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'itemName',
      label: 'Item',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Unitario',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Items',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
      },
    },
  ];

  headerDetailsFileXlsm: Array<params> = [
    { id: 'code', value: 'Código Item' },
    { id: 'itemName', value: 'Nombre Item' },
    { id: 'amount', value: 'Cantidad' },
    { id: 'unitMeasurement', value: 'Unidad' },
    { id: 'costItem', value: 'Costo Unidad' },
    { id: 'totalCostItems', value: 'Costo Total Items' },
    { id: 'description', value: 'Descripción Item' },
  ];

  //filtros superiores
  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'bodegas',
      labelFilter: 'Bodegas',
      urlData: this.urlWarehouses,
      visibleField: 'name',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'item_inventario',
      labelFilter: 'Item',
      urlData: this.urlItems,
      visibleField: 'itemName',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'hoc',
      labelFilter: 'Solicita',
      urlData: this.urlUser,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
      fileNameDb: 'solicita',
    },
    {
      tN: 'hoc',
      labelFilter: 'Autoriza',
      urlData: this.urlUser,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
      fileNameDb: 'autoriza',
    },
    {
      tN: 'terceros',
      labelFilter: 'Proveedor',
      urlData: this.urlProvider,
      visibleField: 'providerName',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'estados_orden_compra',
      labelFilter: 'Estado de Orden',
      urlData: this.urlOrdersStatuses,
      visibleField: 'state',
      primaryKey: 'id',
      type: 'select',
      value: '',
      active: true,
    },
    {
      tN: 'hoc',
      labelFilter: 'Fecha Recepción',
      visibleField: 'fecha_recepcion',
      type: 'date',
      value: '',
    },
    {
      tN: 'hoc',
      labelFilter: 'Fecha Recepción Entre',
      visibleField: 'fecha_recepcion',
      type: 'dateRange',
      value: '',
    },
  ];

  constructor(
    private session: SessionService,
    private router: Router,
    private message: MessageService,
    private http: HttpService,
    private functionEter: FunctionsService,
    private exportData: ExportDataService,
    private deleteItem: DeleteGenericService,
    private notificationService: NotificationsService,
    private utils: UtilsServiceService,
    private storage: LocalStorageService,
    private generatePdf: GeneratePdfFosilService
  ) {}

  async ngOnInit() {
    this.headerFilters[0].active = true;
    this.warehouses = await this.http.getDataBody(`${this.urlWarehouses}`, [
      { id: 'active', value: 1 },
    ]);
    if (this.warehouses.length === 1) {
      this.headerFilters[0].value = this.warehouses[0].id.toString();
    }
  }

  addPO($event: HistoryInventory) {
    let warehouseIdSelected = this.headerFilters[0].value;
    let url = this.utils.getQueryParams(
      `almacen/orden_compra/detalle${
        warehouseIdSelected ? '?warehouseId=' + warehouseIdSelected : ''
      }`
    );
    this.router.navigate([`${url.url}`], {
      queryParams: url.params,
    });
  }

  async editarPO($event: HistoryInventory) {
    let res: Array<HistoryInventory> = await this.http.getDataBody(
      `${this.urlCrudPO}/${$event[0].id}`
    );

    if (res) {
      res[0].receptionDate =
        this.functionEter.dateIso(res[0].receptionDate) + 'T08:00:00.000Z';
      this.session.setData('purchaseOrder', res[0]);
      let url = this.utils.getQueryParams(
        `almacen/orden_compra/detalle${'?warehouseId=' + res[0].warehouseId}`
      );
      this.router.navigate([`${url.url}`], {
        queryParams: url.params,
      });
    }
  }

  async eliminarPO($event: HistoryInventory[]) {
    let res = $event.filter((item) => item.stateId !== 3);
    let notification: Notification = { notified: $event[0].authorize };

    if (res.length !== $event.length) {
      this.message.Warning(
        'Advertencia',
        'Algunas órdenes de compra completadas no se pueden eliminar'
      );
    }

    if (res.length > 0) {
      await this.deleteItem.deleteD(
        res,
        this.urlCrudPO,
        'id',
        'Orden de compra',
        'Ordenes de compra'
      );
      this.notificationService.emitUpdateNotificationsByNotification(
        notification
      );
    }

    this.reloadTablaPO.emit();
  }

  async viewDetail($event: HistoryInventory[]) {
    let res = await this.http.getDataBody<Array<HistoryInventory>>(
      `${this.urlCrudPO}/${$event[0].id}`
    );
    if (res) {
      this.dataDetails = res[0].items;
      this.labesFunction(res[0]);
      this.setHeaderFileXlsm(res[0]);
      this.selected.setValue(1);
    }
  }

  async exportXslxByRow($event: Array<HistoryInventory>) {
    let res = await this.http.getDataBody<Array<HistoryInventory>>(
      `${this.urlCrudPO}/${$event[0].id}`
    );
    if (res) {
      let body = res[0];
      this.setHeaderFileXlsm(body);
      this.exportData.generateToXlsx(
        `Detalle Orden de Compra ${body.consecutive}`,
        this.headerDetailsFileXlsm,
        `Detalle Orden de Compra ${body.consecutive}`,
        body.items
      );
    }
  }

    async print($event: Array<HistoryInventory>){
      await this.generatePdf.generatePurchaseOrderPDF($event[0].id);
    }

  private setHeaderFileXlsm(historyInventory: HistoryInventory) {
    (this.headerDetailsFileXlsm[7] = {
      id: null,
      value: `Consecutivo (#): ${historyInventory.consecutive}`,
    }),
      (this.headerDetailsFileXlsm[8] = {
        id: null,
        value: `Solicita: ${historyInventory.requestsName}`,
      }),
      (this.headerDetailsFileXlsm[9] = {
        id: null,
        value: `Autoriza: ${historyInventory.authorizeName}`,
      }),
      (this.headerDetailsFileXlsm[10] = {
        id: null,
        value: `Fecha de Recepción: ${this.functionEter.dateDB(
          new Date(historyInventory.receptionDate)
        )}`,
      }),
      (this.headerDetailsFileXlsm[11] = {
        id: null,
        value: `Costo Total: $  ${Intl.NumberFormat('es-CO').format(
          historyInventory.totalCost
        )}`,
      });
  }

  private labesFunction(dataHPO: HistoryInventory) {
    this.labels = [
      {
        label: 'Consecutivo (#):',
        value: dataHPO.consecutive,
        edit: false,
      },
      {
        label: 'Solicita:',
        value: dataHPO.requestsName,
        edit: false,
      },
      {
        label: 'Autoriza:',
        value: dataHPO.authorizeName,
        edit: false,
      },
      {
        label: 'Fecha de Recepción:',
        value: this.functionEter.dateDB(new Date(dataHPO.receptionDate)),
        edit: false,
      },
      {
        label: 'Total:',
        value: `$  ${Intl.NumberFormat('es-CO').format(dataHPO.totalCost)}`,
        edit: false,
      },
      {
        label: 'Bodega:',
        value: dataHPO.warehouse,
        edit: false,
      },
    ];
    if (dataHPO?.comment != '') {
      this.labels.push({
        label: 'Comentario:',
        value: dataHPO.comment,
        edit: false,
      });
      this.headerDetailsFileXlsm[12] = {
        id: null,
        value: `Comentario: ${dataHPO.comment}`,
      };
    }
    if (dataHPO.orderId) {
      this.labels.push({
        label: 'Orden:',
        value: dataHPO.orderId,
        edit: false,
      });
      this.headerDetailsFileXlsm[13] = {
        id: null,
        value: `Orden de Trabajo: ${dataHPO.orderId}`,
      };
    }
  }

  async sendEmail($event: PurchaseOrder[]) {
    const providerEmail = $event[0]?.providerEmail;

    if (!providerEmail) {
        this.message.Info('Correo inválido', 'El correo del proveedor no es válido.');
        return;
    }

    const confirmationMessage = 'Confirmación de envío de correo';
    const userConfirmed = await this.message.Info(confirmationMessage, ``, true);

    if (!userConfirmed) {
        return;
    }

    try {
        this.message.openLoading('Cargando', 'Enviando correo');
        const emailData: Provider[] = await this.http.postDataBody(`${EndpointDictionary.PurchaseOrder.POST_EMAIL}`, $event[0]);

        if (emailData.length > 0) {
            const emailList = emailData.map(data => `[${data.providerName} - ${data.email}]`).join('\n');
            this.message.SuccessToast('¡Correo enviado con éxito!');
            console.log('Correos enviados a:\n' + emailList);
        } else {
            this.message.Info('No es posible enviar correo', 'Solo se puede enviar correo a las órdenes que estén en proceso.');
        }
    } catch (error) {
        this.message.Error('Error', 'No se pudo enviar el correo.');
        console.error(error);
    } finally {
        this.message.closeLoading();
    }
}
}
